import React from 'react';

import clsx from 'clsx';
import { Button, ButtonProps } from 'react-bootstrap';
import { LinkProps } from 'react-router-dom';

import PohIcon from '../Icon';

export enum ButtonVariant {
  Primary = 'primary',
  Secondary = 'secondary',
  Success = 'success',
  Danger = 'danger',
  Warning = 'warning',
  Info = 'info',
  Dark = 'dark',
  Light = 'light',
  Link = 'link',
  OutlinePrimary = 'outline-primary',
  OutlineSecondary = 'outline-secondary',
  OutlineSuccess = 'outline-success',
  OutlineDanger = 'outline-danger',
  OutlineWarning = 'outline-warning',
  OutlineInfo = 'outline-info',
  OutlineDark = 'outline-dark',
  OutlineLight = 'outline-light',
}

export enum ButtonSize {
  Small = 'sm',
  Big = 'lg',
  Default = '',
}

const iconButtonPaddingsClass = {
  [ButtonSize.Small]: 'p-1',
  [ButtonSize.Big]: 'p-3',
  [ButtonSize.Default]: 'p-2',
};

interface IPohButtonProps extends Omit<ButtonProps, 'size' | 'as'> {
  onClick?: React.MouseEventHandler;
  variant?: ButtonVariant;
  size?: ButtonSize;
  children?: React.ReactNode;
  block?: boolean;
  type?: 'button' | 'submit' | 'reset' | undefined;
  icon?: any;
  autoFocus?: boolean;
  target?: any;
  as?:
    | ButtonProps['as']
    | React.ForwardRefExoticComponent<LinkProps & React.RefAttributes<HTMLAnchorElement>>;
  to?: string;
}

const PohButton: React.FC<IPohButtonProps> = ({
  children,
  variant = ButtonVariant.Light,
  size = ButtonSize.Default,
  onClick,
  icon,
  block = false,
  disabled = false,
  type = 'button',
  className,
  autoFocus,
  as,
  ...rest
}) => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const content = children || <PohIcon name={icon} />;
  const vari = variant || (icon ? ButtonVariant.Light : ButtonVariant.Primary);

  return (
    <Button
      {...rest}
      variant={vari}
      size={size as any}
      as={as as any}
      onClick={onClick}
      className={clsx(
        icon && iconButtonPaddingsClass[size],
        icon && 'rounded-circle',
        { 'd-block w-100': block },
        className,
      )}
      disabled={disabled}
      type={type}
      autoFocus={autoFocus}
    >
      {content}
    </Button>
  );
};

export default PohButton;
